export default function productCard() {
  return {
    _id: false,
    type: 'droplet.productCard',
    btnText: 'Add to Cart',
    product: null,
    mediaQueries: [
      {
        selector: '.drzProduct-card-cta:hover',
        properties: [
          {
            defaultColor: true,
            property: 'background-color',
            desktop: 'rgba(0, 0, 0, 0.7)',
            tablet: 'default',
            mobile: 'default',
          },
          {
            property: 'color',
            desktop: 'rgba(255, 255, 255, 1)',
            tablet: 'default',
            mobile: 'default',
          },
        ],
      },
    ],
    pageCSS: '',
    bounceDroplet: false,
    isShared: false,
    templateRegion: false,
  };
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/product-card/droplet.schema.js